import { WireAdapter, WireConfigValue } from "lwc";

export class EffectAdapter<T extends WireConfigValue> implements WireAdapter {
  private setValue: (value: T) => void;

  constructor(setValue: (value: T) => void) {
    this.setValue = setValue;
  }

  connect() {}

  disconnect() {}

  update(config: T) {
    this.setValue(config);
  }
}
